import { Pipe, PipeTransform } from '@angular/core';

/**
 *  This fulter is used to limit the length of a certain string
 */

@Pipe({
  name: 'limitLength'
})
export class LimitLength implements PipeTransform {

  transform(value: any, limit: any): string {
    if (!value)
      return;

    if (value.length <= limit) {
        return value;
    }
    return value.substr(0, limit) + '...';
  }
}
